
export default  [
   
    {
        class: 'col-xs-12 col-sm-12 col-md-912 col-lg-912 col-xl-12',
        type: 'text',
        field: 'email',
        label: 'Digite um Email',
        rules: ['required']
    },
];




// WEBPACK FOOTER //
// ./src/components/apps/web/conta-email/_form/email-teste.js